import { h } from "preact";
import {
  shopifyImageUrl,
  shopifyImageSrcset,
} from "../storefront/catalogs";

export function CatalogCard({ catalog, sizes, imageWidth = 600 }) {
  const imageAlt = catalog.image?.altText || catalog.title;
  const Tag = catalog.url ? "a" : "div";
  const linkAttributes = catalog.url ? { href: catalog.url } : {};

  return (
    <Tag class="catalog-card" {...linkAttributes}>
      <span class="catalog-card__image-wrapper">
        {catalog.image ? (
          <img
            class="catalog-card__image"
            src={shopifyImageUrl(catalog.image.url, imageWidth)}
            srcset={shopifyImageSrcset(catalog.image.url)}
            sizes={sizes}
            alt={imageAlt}
            width={catalog.image.width}
            height={catalog.image.height}
            loading="lazy"
          />
        ) : (
          <span class="catalog-card__image-placeholder" />
        )}
      </span>
      <span class="catalog-card__title body-2">{catalog.title}</span>
    </Tag>
  );
}

export function SkeletonCard() {
  return (
    <div class="catalog-card catalog-card--skeleton" aria-hidden="true">
      <span class="catalog-card__image-wrapper">
        <span class="catalog-card__skeleton catalog-card__skeleton--image" />
      </span>
      <span class="catalog-card__title body-2">
        <span class="catalog-card__skeleton catalog-card__skeleton--title" />
      </span>
    </div>
  );
}
